import PropTypes from 'prop-types';

import { breakpoints as defaultGridBreakpoints } from '~/shared/constants/productGrid';

export const breakpointList = [
  'mobile',
  'tablet',
  'tablet+',
  'desktop',
  'desktop+',
];

export const gridColumnsSettingsType = PropTypes.shape(
  breakpointList.map((breakpoint) =>
    PropTypes.shape({ [breakpoint]: PropTypes.number })
  )
);

/**
 * @context
 * This is a utility that adds a grid settings
 * settings with the existing breakpoints
 *
 * @params
 * settings (object)
 *
 * Sample:
 * gridColumns = {
 *  mobile: 2,
 *  desktop: 1
 * }
 *
 * @return
 * This returns the breakpoint array -> [].
 *
 */
export default function addNewGridColumnSettings(settings = {}) {
  if (Object.keys(settings).length > 0) {
    /**
     * We create a Map object from the default breakpoints Array
     */
    const breakpointsMap = new Map(
      defaultGridBreakpoints.map((breakpoint) => [breakpoint.name, breakpoint])
    );

    /**
     *  Manage settings data
     */
    Object.keys(settings).forEach((settingKey) => {
      breakpointsMap.forEach((value, key) => {
        const settingRegex = new RegExp(settingKey, 'gi');

        /**
         *  We set the value of the desired breakpoint
         * if it passes a regex pass
         */
        if (settingRegex.test(key)) {
          const settingValue = settings[settingKey];
          const newBreakpoint = { ...value, columns: settingValue };
          breakpointsMap.set(key, newBreakpoint);
        }
      });
    });

    return Array.from(breakpointsMap.values());
  }

  return defaultGridBreakpoints;
}
